<template>
  <div class="principaleElement">
    <!-- <div class="circle"></div> -->
    <div class="card">
      <div class="logo">
        <img src="../assets/logo.png" alt="" />
        <h2 color="" class="">DAYO - IARD</h2>
       
      </div>
      <h4>CONNECTEZ-VOUS À VOTRE COMPTE</h4>
      <div class="form">
        <v-select
                    outlined
                    v-model="userType"
                    :items="userTypes"
                    label="Type d'utilisateur"
                    prepend-inner-icon="mdi-account"
                    class="clickable"
                  ></v-select>
                  <v-text-field
                    outlined
                    color="#0482fb"
                    v-model="username"
                    type="text"
                    label="Identifiant"
                    placeholder="Identifiant"
                    prepend-inner-icon="mdi-account"
                    class="clickable"
                  />
        <!-- <input
          type="text"
          v-model="username"
          placeholder="Email / Nom d'utilisateur"
        /> -->
        <v-text-field
                outlined
                color="#0482fb"
                v-model="password"
                :type="passwordShow ? 'text' : 'password'"
                label="Password"
                placeholder="Password"
                prepend-inner-icon="mdi-key"
                :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="passwordShow = !passwordShow"
              />
        <!-- <input type="password" v-model="password" placeholder="Mot de passe" /> -->
        <button @click="submitHandler" type="submit">Se connecter</button>
      </div>
      <footer>
        <a href="#">Mot de passe oublié ?</a>
      </footer>
    </div>
  </div>
</template>
  
  <script>
import { mapActions, mapGetters } from "vuex";
import { login } from "@/api/auth";
export default {
  name: "home",
  data: () => ({
    info: [],

    listData: [],
    userTypes: ["Simple users", "Admin"],
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
    loading: false,
    snackbar: false,
    passwordShow: false,
    username: "",
    identifiatRule: [(v) => !!v || "Identifiant Requise"],
    password: "",
    passwordRules: [
      (v) => !!v || "Password is ",
      (v) => (v && v.length >= 6) || "Password must be 6  characters or more!",
    ],
    userType: "Admin",
    Type: "",
    Typerule: [(v) => !!v || "Choix du type d'utilsateur requise"],
  }),
  components: {},
  computed: {
    ...mapGetters([]),
  },
  mounted() {},
  methods: {
    ...mapActions([]),
    async submitHandler() {
      this.loading = true;
      try {
        const response = await login({
          username: this.username,
            password: this.password,
            userType: this.userType,
        })
       
        if (response.success) {
          location.reload();
        } else {
          if (response.message === "This account is not actived") {
            alert("Ce compte n'est pas activé.");
          } else {
            alert("Une erreur s'est produite : " + response.message);
          }
        }
      } catch (error) {
        // alert(error.response.data.error);
        alert("Une erreur s'est produite : " + error.message);
      }
      this.loading = false;
    },
  },
};
</script>
  <style>
* {
  box-sizing: border-box;
}
html {
  height: 100%;
}

body {
  height: 100%;
  display: grid;
  place-items: center;
  margin: 0;
  padding: 0 32px;
  background: url("../assets/bg1.png");
  background-repeat: no-repeat;
  background-size: cover;
  font-family: "Poppins", sans-serif;
  animation: rotate 6s infinite alternate linear;
}
body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #0484fb14; /* Couleur de l'arrière-plan avec opacité */
  z-index: -1;
}


.circle {
  position: fixed;
  top: -50vmin;
  left: -50vmin;
  width: 100vmin;
  height: 100vmin;
  border-radius: 47% 53% 61% 39% / 45% 51% 49% 55%;
  background: #0482fb;
  -webkit-border-radius: 47% 53% 61% 39% / 45% 51% 49% 55%;
  -moz-border-radius: 47% 53% 61% 39% / 45% 51% 49% 55%;
  -ms-border-radius: 47% 53% 61% 39% / 45% 51% 49% 55%;
  -o-border-radius: 47% 53% 61% 39% / 45% 51% 49% 55%;
}

/* .circle::after {
  content: "";
  position: inherit;
  right: -50vmin;
  bottom: -55vmin;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  background: #8cb4e8;
} */

.card {
  overflow: hidden;
  position: relative;
  z-index: 3;
  
  min-width: 500px;
  /* height: 500px; */

display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
  /* margin:  20px; */
  padding: 30px 30px 38px;
  border-radius: 400px !important;
  background: #fff;
  text-align: center;
  /* box-shadow: 100px 100px 100px 100px rgba(69, 68, 68, 0.1); */
}

/* .card::before{
    content: "";
    position: absolute;
    /* background: #189666; 
    border: 5px solid #189666;
    top: -880px;
    left: 50%;
    width: 1000px;
    height: 1000px;
    border-radius: 50%;
    translate: -50% 0;
} */

.card .logo {
  /* position: absolute; */
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  /* border-radius: 50%; */
  background-color: #fff;
  /* height: 64px; */
  width: 100%;

  /* translate: -50% 0; */
}

.card .logo img {
margin-bottom: 20px;
  width: 115px;
}
.card .logo h2 {
  /* font-size: 25px; */
  font-weight: 700;
  display: inline;
  /* margin: 0 0 30px; */
  margin-bottom: 10px;
  color: #2a3444;
}
.danger {
  color: #7c529c;
}
.card > h4 {
  /* font-size: 25px; */
  font-weight: 700;
  /* margin: 0 0 30px; */
  margin-bottom: 30px;
  color: #2a3444;
}

.card  .form {
  margin: 30px;
  display: grid;
  /* gap: 18px; */
  width: 400px;
}

.form > input,
.form > button {
  width: 100%;
  height: 50px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}

.form > input {
  border: 2px solid #e0e0e0;
  font-family: inherit;
  font-size: 16px;
  padding: 0 24px;
  color: #11274c;
  transition: all 0.375s;
}

.form > input:hover {
  border: 2px solid #000;
}

.form > input::placeholder {
  color: #cac8c8;
}

.form > button {
  cursor: pointer;
  width: 100%;
  height: 50px;
  padding: 0 16px;
  background: #0482fb;
  color: #f9f9f9;
  border: 0;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 2px;
  transition: all 0.375s;
}

.form > button:hover {
  color: #fff;
  background: #0b3765;
}

.card > footer {
  color: #7c7c7c;
}

.card > footer > a {
  color: #0482fb;
  transition: all 0.375s;
  text-decoration: none;
}

.card > footer > a:hover {
  color: #0b3765;
}
.theme--light.v-application {
  background: #fff;
  height: 650px !important;
  overflow: hidden !important;
  color: rgba(0, 0, 0, 0.87);
}

@media (width >=500px) {
  body {
    padding: 0;
  }
  .card {
    margin: 0;
    width: 500px;
  }
}
</style>